export default function timestamp() {
  return new Date().getTime();
}
